import { Box, useTheme } from "@mui/material";
import dayjs from "dayjs";
import { useSortBy, useTable } from "react-table";

import { P1 } from "@/Components";
import { Caret } from "@/Components/Icons";
import { formatDateLocale } from "@/shared/utils/formatDate";
import { colors } from "@/Utils";
import { commaFormate } from "@/Utils";

export const NewTableContent = ({
  columns,
  initialState,
  data,
  numbers,
  wrapperWidth,
  currencySign,
  formatCurrency,
  scroll,
}) => {
  const theme = useTheme();
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
    {
      columns,
      initialState,
      data,
    },
    useSortBy
  );

  const convertTdContent = (data, header, currencySign, formatCurrency) => {
    try {
      if (header === "Date") {
        return formatDateLocale(dayjs(data), { yearFormat: "YY" });
      }
      if (header === `Total Sales ${currencySign}`) {
        return formatCurrency(data);
      }
      if (header === "Total return ") {
        return commaFormate(data);
      }
      return commaFormate(data);
    } catch (error) {
      return data;
    }
  };

  return (
    <Box
      sx={{
        boxSizing: "border-box",
        overflowX: scroll ? "scroll" : "auto",
        width: wrapperWidth ? wrapperWidth : "100%",
        "&::-webkit-scrollbar": {
          height: "9px",
          cursor: "pointer",
        },
        "&::-webkit-scrollbar-track": {
          WebkitBoxShadow:
            theme.palette.mode === "light"
              ? "inset 0 0 30px #f4f4f4"
              : `inset 0 0 30px ${colors.lightBlack}`,
          borderRadius: "3px",
        },
        "&::-webkit-scrollbar-thumb": {
          borderRadius: "3px",
          width: "5px",
          WebkitWidth: 5,
          height: "5px",
          WebkitHeight: 5,
          WebkitBoxShadow: `inset 30 0 0px ${colors.bodyMain}`,
          background: theme.palette.mode === "light" ? colors.darkWhite : colors.SelectBg,
          cursor: "pointer",
        },
      }}
    >
      <table {...getTableProps()} style={{ width: "100%" }}>
        <thead>
          {headerGroups.map((headerGroup, headerGroupIndex) => (
            <tr {...headerGroup.getHeaderGroupProps()} key={`header-${headerGroupIndex}`}>
              {headerGroup.headers.map((column) => (
                <Box
                  component="th"
                  numbers={numbers}
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  key={column.id}
                  sx={{
                    backgroundColor:
                      theme.palette.mode === "dark" ? colors.bodyMain : colors.secondaryColor,
                    borderRadius: "3px",
                    padding: "8px",
                    minWidth: numbers ? `calc(912px / ${numbers} - 16px - 4px)` : "inherit",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexDirection: "row",
                    }}
                  >
                    <P1 fSize={13} fweight={600} mrright={50} display="inline" whiteSpace="nowrap">
                      {column.render("Header")}
                    </P1>
                    <Box>
                      <Caret
                        enable={column.isSorted ? (column.isSortedDesc ? "top" : "bottom") : ""}
                      />
                    </Box>
                  </Box>
                </Box>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} key={row.index}>
                {row.cells.map((cell, cellIndex) => {
                  return (
                    <Box
                      component="td"
                      numbers={numbers}
                      {...cell.getCellProps()}
                      key={`cell-${cellIndex}`}
                      sx={{
                        padding: "8px",
                        borderBottom: `1px solid ${colors.lightGray}`,
                        minWidth: numbers ? `calc(912px / ${numbers} - 16px - 4px)` : "inherit",
                      }}
                    >
                      <Box>
                        {cell.value === null ? (
                          <P1 fSize={11} color={colors.lightGray}>
                            No Data
                          </P1>
                        ) : (
                          <P1 fSize={11}>
                            {convertTdContent(
                              cell.render("Cell").props.value,
                              cell.column.Header,
                              currencySign,
                              formatCurrency
                            )}
                          </P1>
                        )}
                      </Box>
                    </Box>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </Box>
  );
};
